export default __webpack_public_path__ + "static/paper2-28f703ab687d0f66ffa890feb4bc59fc.png";